<template>
  <body>  

     
    <div id="content">
      <iframe src="https://app.bdb.ai/home/#/opendocument?data=eyJ1c2VyIjoiMTQwOTAyNCIsInNwYWNla2V5IjoiMzMwNiIsImRvY0lkIjoiNDI3NjY2MTEzIiwiYWxnIjoiSFMyNTYiLCJ6aXAiOiJHWklQIn0.H4sIAAAAAAAAADWQy3KCMAAA_4Vz4xAESXrj4SNQ1JAC2otDgEDSUVFE0U7_vXro3va2sz-aukjtXYOmjnXD1N60rudPr-5Bw-eFXMmAJA8Cl5J05NC2hUcm5LvMWepIQUcLsyPOP64RRdT2iXNzdoBYDvqqC58XqO6z1otZGu7b2G-TRFgVXI37RvWNyLZbkw0UIzEIhmaxuiKe9-WBjiM1lXghLo9KpBkJl-lDmTw-ISsQ6Xw3M1TgZeDEkvtm5XkO5xlQpmw-TwEJcbyZ1eoIY512Fl1u7RrU04E1x7Okr9CRJezEBrvh-gEkO87Xbn9YwyvoXDopovM-0J_1fuixzNWfR2TXvY6IPEdGhSEWBi8hNu3cmlSwNCqELFxh7fcP1gecnEwBAAA.DzEHh6ob3FsDN6f5DqxYLos8qkq6SjPEZHTUQxCKoOg"></iframe>
    </div>


</body>
</template>


<script>

  export default {
    name: 'markdownDashboard'
  }

</script>

<style media="screen" scoped>

iframe {

  border: none;
  height: 100vh;       
  width: 95vw;
  margin-left: -8px;
}
</style>


// WEBPACK FOOTER //
// src/components/api/v1/warehouse/dashboards/markdownDashboard.vue